import { render, staticRenderFns } from "./viewOrderDetails.vue?vue&type=template&id=df65ff28"
import script from "./viewOrderDetails.vue?vue&type=script&lang=js"
export * from "./viewOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./viewOrderDetails.vue?vue&type=style&index=0&id=df65ff28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports